export default "__VITE_ASSET__BKOZ6AZ4__ 400w, __VITE_ASSET__DAEYI$u0__ 800w, __VITE_ASSET__BKy40Czc__ 1200w";